import { useAtomValue } from 'jotai';
import { Source } from 'react-map-gl';
import { Layer, LayerBand, LAYER_ORDER } from './ordered-layer';
import { createMapSourceAtom } from './atoms';
import { MapUserConfigAtom } from './types';
import { useMemo } from 'react';

// z-order is enforced centrally by useEnforceLayerOrder (see layer-order.ts).
const BasinLayer = ({
  mapConfigAtom,
}: {
  mapConfigAtom: MapUserConfigAtom;
}) => {
  const basinsSourceAtom = useMemo(() => createMapSourceAtom('basins'), []);
  const basinsSource = useAtomValue(basinsSourceAtom);
  const mapConfig = useAtomValue(mapConfigAtom);
  if (!basinsSource) return null;

  return (
    <LayerBand band={LAYER_ORDER.tierBasin}>
      <Source id="basins" type="vector" url={basinsSource}>
        {mapConfig.basinTier.options.basin && (
          <Layer
            source-layer="basins"
            id="basin-fill"
            type="fill"
            paint={{
              'fill-color': [
                'match',
                ['get', 'gis_basin'],
                'MIDLAND',
                '#E8B4D9',
                'DELAWARE',
                '#D0BEEB',
                'CENTRAL PLATFORM',
                '#B7C5E5',
                'EAGLE FORD',
                '#9ECFE0',
                'HAYNESVILLE',
                '#86D8D4',
                'BARNETT',
                '#6BD8C6',
                'WOODFORD',
                '#6ED9B9',
                'NIOBRARA',
                '#8DD3A7',
                'BAKKEN',
                '#B6CBA0',
                'MARCELLUS',
                '#D1C18E',
                'UTICA',
                '#D9B28C',
                '#EFD9CE',
              ],
              'fill-opacity': 0.4,
            }}
          />
        )}
      </Source>
    </LayerBand>
  );
};

export { BasinLayer };
